angular.module('dnecom')
    .controller('StoreIntegrationsSettingsController', ["$scope", "StoreUtils", "IntegrationsUtils", "notifications", function ($scope, StoreUtils, IntegrationsUtils, notifications) {
        $scope.autoresponderLists = [];
        const AccountsGroupEnum = {
            'aweber': 'AWeber',
            'getresponse': 'GetResponse',
            'google': 'Google',
            'braintree': 'Credit Cards',
            'paypal': 'PayPal',
            'paypal_express': 'PayPal',
            'stripe': 'Credit Cards',
            'paystack': 'Credit Cards',
            'fondy': 'Credit Cards',
            'payfast': 'Credit Cards',
            'mailchimp': 'MailChimp',
            'facebookpixel': 'FacebookPixel',
            'sendlane':'Sendlane',
            'sendgrid':'Sendgrid',
            'activecampaign': 'ActiveCampaign',
            'convertkit': 'ConvertKit',
            'mcafee': 'McAfee',
            'cod': 'Cash on delivery',
            'pod': 'Payment on delivery',
            'pop': 'Payment on pickup',
        };
        const AccountsTypesEnum = {
            'aweber': 'AWeber',
            'getresponse': 'GetResponse',
            'google': 'Google',
            'braintree': 'Braintree',
            'paypal': 'PayPal',
            'paypal_express': 'PayPal Express',
            'stripe': 'Stripe',
            'paystack': 'Paystack',
            'fondy': 'Fondy',
            'payfast': 'Payfast',
            'mailchimp': 'MailChimp',
            'facebookpixel': 'FacebookPixel',
            'sendlane':'Sendlane',
            'sendgrid':'Sendgrid',
            'activecampaign': 'ActiveCampaign',
            'convertkit': 'ConvertKit',
            'mcafee': 'McAfee',
            'cod': 'Cash on delivery',
            'pod': 'Payment on delivery',
            'pop': 'Payment on pickup',
        };

        $scope.autoresponderListsLoading = false;
        $scope.selectedAutoresponderType = false;

        $scope.activePaymentTypes = TemplateData.value('activePaymentTypes');
        $scope.activeAutoresponderTypes = TemplateData.value('activeAutoresponderTypes');
        $scope.currency = TemplateData.value('currency');
        if ($scope.currency && !$scope.currency.isSupportedByPayPal) {
            $scope.activePaymentTypes.indexOf('paypal') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paypal'), 1);
            $scope.activePaymentTypes.indexOf('paypal_express') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paypal_express'), 1);
        }
        if ($scope.currency && !$scope.currency.isSupportedByStripe) {
            $scope.activePaymentTypes.indexOf('stripe') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('stripe'), 1);
        }
        if ($scope.currency && !$scope.currency.isSupportedByFondy) {
            $scope.activePaymentTypes.indexOf('fondy') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('fondy'), 1);
        }
        if ($scope.currency && !$scope.currency.isSupportedByBraintree) {
            $scope.activePaymentTypes.indexOf('braintree') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('braintree'), 1);
        }

        $scope.accounts = [];
        $scope.noAccounts = true;

        IntegrationsUtils.getAccountsByTypes(function (accounts) {
            $scope.accounts = accounts;
            $scope.noAccounts = _.isEmpty($scope.accounts);

            if ($scope.activePaymentTypes.indexOf('paystack') > -1 && $scope.accounts.paystack && $scope.currency) {
                let acceptedAccounts = [];
                $scope.accounts.paystack.forEach(function (account) {
                    if (account.properties.currency && account.properties.currency === $scope.currency.code) {
                        acceptedAccounts.push(account);
                    }
                });
                if (!acceptedAccounts.length) {
                    $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paystack'), 1);
                } else {
                    $scope.accounts.paystack = acceptedAccounts;
                }
            }
            if (
                $scope.activePaymentTypes.indexOf('payfast') > -1
                && (!$scope.currency || !$scope.currency.code || $scope.currency.code.toLowerCase() != 'zar')
            ) {
                $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('payfast'), 1);
            }
        });

        $scope.init = function(mode) {
            $scope.mode = mode;

            if (mode === 'mobile'
                && $scope.store
                && $scope.store.properties
                && $scope.store.properties.integrations) {
                $scope.refreshAutoresponderList($scope.store.properties.integrations.autoresponder);
            }
        };

        $scope.areAutorespondersAvailable = function() {
            return $scope.accounts && (
                $scope.accounts.getresponse
                || $scope.accounts.aweber
                || $scope.accounts.mailchimp
                || $scope.accounts.sendlane
                || $scope.accounts.convertkit
                || $scope.accounts.sendgrid
                || $scope.accounts.activecampaign
            );
        };

        $scope.changeAutoresponderAccount = function() {
            $scope.refreshAutoresponderList($scope.store.properties.integrations.autoresponder);
            $scope.store.properties.integrations.autoresponderListForAbandons = null;

            try{
                if(typeof $scope.store.mobileProperties != 'undefined'){
    	            $scope.store.mobileProperties.integrations.autoresponder = $scope.store.properties.integrations.autoresponder;
    	            $scope.store.mobileProperties.integrations.autoresponderListForAbandons = null;
    	        }
            }catch(e){

            }
        };

        $scope.refreshAutoresponderList = function (accountId) {
            if (!accountId) {
                $scope.autoresponderLists = [];
                return;
            }

            $scope.autoresponderListsLoading = true;

            IntegrationsUtils.getAutoResponderList($scope.store.id, accountId, function (list) {
                $scope.autoresponderLists = [];
                $scope.autoresponderListsLoading = false;

                if (list.length > 0) {
                    jQuery.each(list, function(idx, item){
                        $scope.autoresponderLists.push(item);
                    });
                }
            }, function (response) {
                $scope.autoresponderListsLoading = false;
                $scope.store.properties.integrations.autoresponder = null;
                $scope.store.properties.integrations.autoresponderListForAbandons = null;
                notifications.danger(response.data.message);
            });

            $scope.selectedAutoresponderType = $scope.getAutoresponderType(accountId);
        };

        $scope.normalizeAccountType = function(type) {
            return AccountsGroupEnum[type];
        };

        $scope.filterOutType = function(type) {
            return function(account) {
                return !(AccountsGroupEnum[account.type] === AccountsGroupEnum[type]
                    || (type === 'braintree' && AccountsGroupEnum[account.type] === 'PayPal')
                    || (AccountsGroupEnum[type] === 'PayPal' && account.type === 'braintree'));
            }
        };

        $scope.fetchAccounts = function(types) {
            return _.map(_.flatten(_.values(_.pick($scope.accounts, types))), function(account) {
                account.accountId = account.id;

                return account;
            });
        };

        $scope.getAutoresponderAccountName = function() {
            var accounts = _.flatten(_.values(_.pick($scope.accounts, $scope.activeAutoresponderTypes)));

            for (var i = 0; i < accounts.length; i++) {
                if (accounts[i].id == $scope.store.properties.integrations.autoresponder) {
                    return accounts[i].name;
                }
            }

            return '';
        };

        $scope.addNewPaymentMethod = function(account) {
            if ($scope.mode === 'mobile') {
                $scope.store.mobilePaymentMethods.push({
                    accountId: account.id
                });
            } else {
                $scope.store.paymentMethods.push({
                    accountId: account.id
                });
            }
        };

        $scope.getAutoresponderType = function(accountId) {
            if (accountId && $scope.accounts) {
                for (var key in $scope.accounts) {
                    for (var j = 0; j < $scope.accounts[key].length; j++) {
                        if ($scope.accounts[key][j].id == accountId)
                            return $scope.accounts[key][j].type;
                    }
                }
            }

            return false;
        };

        $scope.getAccountPrefix = function (account) {
            if (account && ['pop', 'pod'].includes(account.type) && $scope.store.paymentMethods.some(pm => pm && pm.accountId === account.id)) {
                return account.typeName + ' - ';
            }

            if (account && ['Credit Cards', 'PayPal'].includes(AccountsGroupEnum[account.type])) {
                return AccountsTypesEnum[account.type] + ' - ';
            }

            return '';
        }
        $scope.getMobileAccountPrefix = function (account) {
            if (account && ['pop', 'pod'].includes(account.type) && $scope.store.mobilePaymentMethods.some(pm => pm && pm.accountId === account.id)) {
                return account.typeName + ' - ';
            }

            if (account && ['Credit Cards', 'PayPal'].includes(AccountsGroupEnum[account.type])) {
                return AccountsTypesEnum[account.type] + ' - ';
            }

            return '';
        }

        $scope.filterPaymentMethods = function (method) {
            if (method) {
                $scope.store.paymentMethods = $scope.store.paymentMethods.filter(function( obj ) {
                    return obj === method
                        || (obj && method.type !== 'braintree' && AccountsGroupEnum[obj.type] !== AccountsGroupEnum[method.type])
                        || (obj && method.type === 'braintree' && ['pod', 'pop'].includes(obj.type));
                });
            }
        };

        $scope.filterMobilePaymentMethods = function (method) {
            if (method) {
                $scope.store.mobilePaymentMethods = $scope.store.mobilePaymentMethods.filter(function( obj ) {
                    return obj === method
                        || (obj && method.type !== 'braintree' && AccountsGroupEnum[obj.type] !== AccountsGroupEnum[method.type])
                        || (obj && method.type === 'braintree' && ['pod', 'pop'].includes(obj.type));
                });
            }
        };
    }]);
